// extracted by mini-css-extract-plugin
module.exports = {"volunteerCards":"VolunteerCards_volunteerCards__kQMme","cardsContainer":"VolunteerCards_cardsContainer__2ff3p","card":"VolunteerCards_card__aY1Zw"};